import * as React from 'react';

import { BlogFields, fields } from '../consts';
import { STATUSES_OPTIONS } from 'common/consts';
import BlogCoreWithGet from '../components/BlogCoreWithGet';

const createBlogDefaults = (): BlogFields => ({
  [fields.status.name]: [STATUSES_OPTIONS[0]],
  [fields.title.name]: '',
  [fields.description.name]: '',
  [fields.url.name]: '',
  [fields.image_url.name]: '',
  [fields.is_featured.name]: false,
  [fields.is_inspiration.name]: false,
});

const BlogsCreate = () => {
  const defaultValues = createBlogDefaults();

  return (
    <>
      <BlogCoreWithGet defaultValues={defaultValues} layout="creation" />
    </>
  );
};

export default BlogsCreate;
